/**
 * Chord.js
 * Chord Chart to show relationships between nodes
 *
 * @class   Chord
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Chord',

	propTypes: {

	},

	render() {

		return <h3>Chord Chart</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/chord/Chord.js
 **/